export default "__VITE_ASSET__Tol418hz__"